/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Country_FreeInputs */

const en_pricing_country_free = /** @type {(inputs: Pricing_Country_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`India / Philippines (free plan)`)
};

const es_pricing_country_free = /** @type {(inputs: Pricing_Country_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`India / Filipinas (plan gratis)`)
};

/**
* | output |
* | --- |
* | "India / Philippines (free plan)" |
*
* @param {Pricing_Country_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_country_free = /** @type {((inputs?: Pricing_Country_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Country_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_country_free(inputs)
	return en_pricing_country_free(inputs)
});